if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        const value = event.currentTarget.dataset.value;

        const shopDomain =
          typeof orbito !== 'undefined' && orbito.getCountryDomain
            ? orbito.getCountryDomain() || window.location.hostname.replace(/^www\./, '')
            : window.location.hostname.replace(/^www\./, '');

        const inputCountry = form ? form.querySelector('input[name="country_code"]') : null;
        const inputLanguage = form ? form.querySelector('input[name="locale_code"]') : null;
        const returnToInput = form ? form.querySelector('input[name="return_to"]') : null;
        const localeCode = inputCountry ? event.currentTarget.dataset.localeCode : value;

        if (inputCountry && returnToInput) {
          // Build target URL with correct country param so redirect always shows ?country=value
          const pathname = window.location.pathname;
          const searchParams = new URLSearchParams(window.location.search);
          searchParams.set('country', value);
          const newSearch = searchParams.toString();
          const targetUrl = pathname + (newSearch ? `?${newSearch}` : '');
          returnToInput.value = targetUrl;
          document.cookie = `mdApp_countryCodeDomain=${value}; domain=${shopDomain}; path=/; max-age=${60 * 60 * 24 * 60};`;
        }

        if (inputLanguage && localeCode) {
          inputLanguage.value = localeCode;
          document.cookie = `mdApp_showRecommendationLang=${localeCode}; domain=${shopDomain}; path=/; max-age=${60 * 60 * 24 * 60};`;
        }

        if (inputCountry) {
          inputCountry.value = value;
        } else {
          this.elements.input.value = value;
        }

        if (form && inputCountry && returnToInput) {
          // Country form: submit via fetch then redirect client-side so URL always has correct ?country=
          // (server redirect may ignore return_to and use referrer/current URL)
          const targetUrl = returnToInput.value;
          const formData = new FormData(form);
          fetch(form.action, {
            method: form.method || 'post',
            body: formData,
            redirect: 'follow',
          })
            .then((response) => {
              const redirectUrl = new URL(response.redirected ? response.url : targetUrl, window.location.origin);
              redirectUrl.searchParams.set('country', value);
              window.location.href = redirectUrl.toString();
            })
            .catch(() => {
              form.submit();
            });
        } else if (form) {
          form.submit();
        }
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    }
  );
}
